<template>
  <v-row
    align="stretch"
    justify="start"
  >
    <v-col
      cols="12"
    >
      <base-material-card
        color="coolrunner"
        icon="mdi-tag-multiple"
        inline
        class="px-5 py-3"
        lg="4"
      >
        <template v-slot:after-heading>
          <div class="text-h2 font-weight-light">
            {{ $t('price_sheet') }}
          </div>
        </template>
        <v-row>
          <v-col
            cols="12"
          >
            <v-switch
              v-model="future"
              label="Vis fremtidige priser"
              color="primary"
              value="primary"
              hide-details
            />
          </v-col>
          <v-col
            v-if="loading"
            cols="12"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            />
          </v-col>

          <v-col
            cols="12"
            lg="12"
          >
            <v-expansion-panels>
              <v-expansion-panel
                v-for="(group, key) in groupedPrices"
                :key="key"
              >
                <v-expansion-panel-header>{{ $t('from') }} {{ getCountryName(key, $i18n.locale) }}</v-expansion-panel-header>

                <v-expansion-panel-content>
                  <v-expansion-panels multiple>
                    <v-expansion-panel
                      v-for="(to, toKey) in groupByToCountry(group)"
                      :key="toKey"
                    >
                      <v-expansion-panel-header>
                        {{ $t('to') }} {{ getCountryName(toKey, $i18n.locale) }}
                      </v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <v-simple-table
                          dense
                          class="mt-4 price-list"
                        >
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th
                                  :width="context === 'customers' ? '1%' : '100%'"
                                  class="display-1"
                                >
                                  {{ $t('name') }}
                                </th>
                                <th
                                  v-if="context === 'customers'"
                                  width="100%"
                                  class="display-1"
                                >
                                  {{ $t('type') }}
                                </th>
                                <th class="display-1">
                                  {{ $t('price') }} {{ $t('incl_tax') }}
                                </th>
                                <th class="display-1">
                                  {{ $t('price') }} {{ $t('excl_tax') }}
                                </th>
                                <th class="display-1">
                                  {{ $t('fuel') }} {{ $t('excl_tax') }}
                                </th>
                                <th class="display-1">
                                  {{ $t('fuel') }} {{ $t('percentage') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <v-tooltip
                                v-for="item in to"
                                :key="item.title_full"
                                bottom
                              >
                                <template
                                  v-slot:activator="{ on, attrs }"
                                >
                                  <tr
                                    v-on="on"
                                  >
                                    <td>{{ item.title_full }}</td>
                                    <td
                                      v-if="context === 'customers'"
                                      class="display-1"
                                    >
                                      {{ item.price_type_name }}
                                    </td>
                                    <td align="right">
                                      {{ item.price_incl_tax.toFixed(2) }} {{ item.currency }}
                                    </td>
                                    <td align="right">
                                      {{ item.price_excl_tax.toFixed(2) }} {{ item.currency }}
                                    </td>
                                    <td align="right">
                                      {{ item.prices.fuel.toFixed(2) }} {{ item.currency }}
                                    </td>
                                    <td align="right">
                                      {{ item.fuel_percentage || 0 }}%
                                    </td>
                                  </tr>
                                </template>
                                <span>{{ item.cps }}</span>
                              </v-tooltip>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </base-material-card>
    </v-col>
  </v-row>
</template>
<script>
  import { getName as getCountryName } from 'i18n-iso-countries'

  export default {
    props: {
      lastUpdated: {
        type: Number,
        default: null,
      },
      context: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        items: [],
        future: false,
        loading: false,
      }
    },
    computed: {
      groupedPrices: function () {
        return this.$_.groupBy(this.items, 'zone_from')
      },
    },
    watch: {
      lastUpdated: function () {
        this.getDataFromApi()
      },
      future: function () {
        this.getDataFromApi()
      },

    },
    mounted: function () {
      this.getDataFromApi()
    },
    methods: {
      getDataFromApi: function () {
        this.loading = true
        this.items = []
        this.$get(`/${this.context}/${this.$route.params.id}/sheet?future=${this.future ? 1 : 0}`, {})
          .then(res => {
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
      },
      getCountryName: function (val, lang) {
        if (val.toLowerCase() === 'xi') { return 'United Kingdom (Northern Ireland)' }
        return getCountryName(val, lang)
      },
      groupByToCountry: function (list) {
        return this.$_.groupBy(this.$_.sortBy(list, 'zone_to'), 'zone_to')
      },
    },
  }
</script>

<style lang="sass" scoped>
.price-list tbody tr:nth-of-type(even)
    background: #F6F6F6
</style>
